<template>
  <li class="v-breadcrumbs-item"
      :class="[classes]">
    <a v-if="item.href" :href="item.href" :aria-label="item.text">
      <slot/>

      <v-icon icon="chevron-right"></v-icon>
    </a>

    <template v-else>
      <slot/>

      <v-icon icon="chevron-right"></v-icon>
    </template>
  </li>
</template>

<script>

export default {
  name: 'VBreadcrumbsItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    classes() {
      return {
        'v-breadcrumbs-item--disabled': !!this.item.disabled,
      }
    },
  },
};
</script>
